import { h } from 'preact';

/**
 * Consistent form error.
 *
 * @param props.error The error message to display.
 * @param props.className Optional class name to add to the wrapper.
 */
const FormError = ({
	error,
	className = '',
}:{
	error: string,
	className?: string,
}) => (
	<div
		className={[
			'ea-form-error',
			className,
		].join(' ')}
	>
		<span>{error}</span>
	</div>
);

export default FormError;
